// extracted by css-extract-rspack-plugin
export default {"container":"Selection-module__container__uRQcanH","checkbox":"Selection-module__checkbox__xSfFSUp"};